<template>
    <div class="supplier_score">

        <v-container>
            <v-row>
                <v-col>

                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                      <tr>
                        <th class="text-left">項目</th>
                        <th class="text-left">評価</th>
                        <th class="text-left">評価件数</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(mp,idx) in score" :key="mp.evaluateItemCd">
                        <td>{{ mp.evaluateItemName }}</td>
                        <td>
                          <v-rating
                              v-model="mp.score"
                              background-color="white"
                              color="yellow accent-4"
                              dense
                              readonly
                              half-increments
                              size="18"
                          ></v-rating>

                        </td>
                        <td>{{ mp.evaluateCount }}件</td>
                      </tr>
                      </tbody>

                    </template>
                  </v-simple-table>

                </v-col>
                <v-col>
                    <!-- グラフ -->
                    <RadarChart :values="score"></RadarChart>
                </v-col>
            </v-row>

            <v-row>

              <v-col>
                <span>強み</span>
                <v-card v-for="f in strongFeatures" :key="f.id" outlined elevation="0" class="mt-2">
                  <v-card-text class="pt-1 pb-0">{{ f.content }}</v-card-text>
                  <v-card-subtitle class="pt-0 pb-1" style="text-align: right">{{ f.createAt }} {{ getStaffName(f.userId) }}</v-card-subtitle>

                </v-card>

              </v-col>

              <v-col>
                <span>弱み</span>
                
                <div v-if="!weakFeatures || weakFeatures.length === 0" class="mt-2">まだ投稿されていません</div>

                <v-card v-for="f in weakFeatures" :key="f.id" outlined elevation="0" class="mt-2">
                  <v-card-text class="pt-1 pb-0">{{ f.content }}</v-card-text>
                  <v-card-subtitle class="pt-0 pb-1" style="text-align: right">{{ f.createAt }} {{ getStaffName(f.userId) }}</v-card-subtitle>
                </v-card>

              </v-col>

            </v-row>

        </v-container>

    </div>
</template>
<script>

import BaseView from "../../components/BaseView";
import RadarChart from "../../components/RadarChart";

export default {
    mixins:[BaseView],
    components: {
        RadarChart
    },
    props: {
        score: Array,
        features:Array
    },
    data: () => ({
        isInitialized:false,
        isFetched:false,
        isLoading:false,
        isDownloading:false,

        condition:{},
        pager:{},
        errors:{},
    }),
    computed: {
      strongFeatures:function (){
        return this.features.filter(a => a.featureClass === "S")
      },
      weakFeatures:function (){
        return this.features.filter(a => a.featureClass === "W")
      },
    },
    mounted:function() {
        this.setupConditions();
    },
    created:function() {
    },
    watch: {
        '$route':function (to, from) {
            this.setupConditions();
        },
    },
    methods: {
        setupConditions(){

        },

    },

}
</script>